<template>
	<section class=""></section>
</template>

<script>
export default {

  name: 'announcements',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
	section {
		background-image: url('../../assets/announcements/announcement.svg');
		background-position: center;
		background-size: contain;
		background-repeat: no-repeat;
		width: 100%;
		height: 850px;
	}
</style>